<div>
  <div class="row">
    <div class="col-lg-12">
      <h1 class="mb-3">Payment Arrangement</h1>
      <p>To make it easier to manage your current bill, you can set up an interest-free payment plan with regular weekly, fortnightly or monthly payments of equal amounts.</p>
      <p>When you set up your plan, and each time you change it, we will send you a payment schedule with:</p>
      <ul>
        <li>the number of payments you need to make to pay off any debt on your account</li>
        <li>how long you will be making payments</li>
        <li>the amount and due date of each payment.</li>
      </ul>
      <p>If you miss a payment due date, we'll contact you to revise your payment plan and help you get back on track.</p>
      <p>If you are in financial difficulty and cannot commit to paying future bills, you may like to speak with our team for more options.</p>
      <p>Approved payment arrangement requests will receive either an email or text confirmation within 3 business days.</p>
      <p><strong style="font-weight: 700; text-shadow: 0.5px 0 0 currentColor, -0.5px 0 0 currentColor;">Note:</strong> If you have more than one account, you will need to submit individual forms for each account.</p>
      <p><strong style="font-weight: 700; text-shadow: 0.5px 0 0 currentColor, -0.5px 0 0 currentColor;">Do you pay via Direct Debit?</strong></p>
      <p>If you establish a payment arrangement, the Direct Debit arrangement with your financial institution will be cancelled by our team. You can re-apply for a Direct Debit when you receive your next bill. PAYMENT ARRANGEMENT INSTALMENTS CAN NOT BE PAID VIA DIRECT DEBIT.</p>
      <p><strong style="font-weight: 700; text-shadow: 0.5px 0 0 currentColor, -0.5px 0 0 currentColor;">Property owner</strong></p>
      <p>{{applicationData?.or_first_name}}</p>
      <p><strong style="font-weight: 700; text-shadow: 0.5px 0 0 currentColor, -0.5px 0 0 currentColor;">Serviced address</strong></p>
      <p>{{applicationData?.sr_address}}</p>
      <p><strong style="font-weight: 700; text-shadow: 0.5px 0 0 currentColor, -0.5px 0 0 currentColor;">Your customer reference number</strong></p>
      <p>{{applicationData?.sr_customer_ref}}</p>
      <p><strong style="font-weight: 700; text-shadow: 0.5px 0 0 currentColor, -0.5px 0 0 currentColor;">Amount due</strong></p>
      <p>{{applicationData?.sr_pa_amount_due}}</p>
    </div>
  </div>
  <form #paymentForm="ngForm"  name="paymentForm" (ngSubmit)="updatePayArrangement($event)">
    <div class="row">
      <div class="col-sm-12 col-md-8">
        <p><strong style="font-weight: 700; text-shadow: 0.5px 0 0 currentColor, -0.5px 0 0 currentColor;">Future bills</strong></p>
        <!-- Future bills-->
        <label for="futureBills" class="mb-1"><p>As this arrangement is only for the amount due shown above, are you able to pay future bills in full? (optional)</p></label>
        <div class="form-group mb-3">
          <select
            id="futureBills"
            name="futureBills"
            [(ngModel)]="futureBillsProperty"
            required
            #futureBillsCtrl="ngModel"
            class="form-control col-md-6"
            [class.is-invalid]="futureBillsCtrl.invalid && (futureBillsCtrl.dirty || futureBillsCtrl.touched)"
            aria-label="Make a selection">
            <option [value]="null" disabled>--Make a selection--</option>
            <option value="yes">Yes</option>
            <option value="no">No</option>
            <option value="unsure">Unsure</option>
          </select>
          @if (futureBillsCtrl.invalid && (futureBillsCtrl.dirty || futureBillsCtrl.touched)) {
            <div class="error">
              @if (futureBillsCtrl.errors?.['required']) {
                <div class="invalid-feedback d-block">You must choose an option, please try again.</div>
              }
            </div>
          }
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-md-8">
        <p><strong style="font-weight: 700; text-shadow: 0.5px 0 0 currentColor, -0.5px 0 0 currentColor;">Payment installments</strong></p>

        <!-- Installment Frequency-->
        <label for="installmentFrequency" class="mb-1"><p>When would you like your payments to occur?</p></label>
        <div class="form-group mb-3">
          <select
            id="installmentFrequency"
            name="installmentFrequency"
            [(ngModel)]="installmentFrequencyProperty"
            required
            #installmentFrequencyCtrl="ngModel" class="form-control col-md-6" (change)="onChangeFrequency(installmentFrequencyProperty)"
            [class.is-invalid]="installmentFrequencyCtrl.invalid && (installmentFrequencyCtrl.dirty || installmentFrequencyCtrl.touched)"
            aria-label="Make a selection">
            <option [value]="null" disabled>--Make a selection--</option>
            @for (frequency of availableFrequency; track frequency) {
              <option [value]="frequency.name">
                {{ frequency.name }}
              </option>
            }
          </select>
          @if (installmentFrequencyCtrl.invalid && (installmentFrequencyCtrl.dirty || installmentFrequencyCtrl.touched)) {
            <div class="error">
              @if (installmentFrequencyCtrl.errors?.['required']) {
                <div class="invalid-feedback d-block">You must choose an option, please try again.</div>
              }
            </div>
          }
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-md-8">
        <!-- Installment Count-->
        <label for="installmentCount" class="mb-1"><p>How many installments would you like to make?</p></label>
        <div class="form-group mb-3">
          <select
            id="installmentCount"
            name="installmentCount"
            [(ngModel)]="installmentCountID"
            required
            #installmentCountCtrl="ngModel" class="form-control col-md-6" (change)="onChangeInstallment(installmentCountID)"
            [class.is-invalid]="installmentCountCtrl.invalid && (installmentCountCtrl.dirty || installmentCountCtrl.touched)" aria-label="Make a selection" required>
            <option [value]="null" disabled>--Make a selection--</option>
            @for (count of filteredCounts; track count) {
              <option [value]="count.id">
                {{ count.count }}
              </option>
            }
          </select>
          @if (installmentCountCtrl.invalid && (installmentCountCtrl.dirty || installmentCountCtrl.touched)) {
            <div>
              @if (installmentCountCtrl.errors?.['required']) {
                <div class="invalid-feedback d-block">You must choose an option, please try again.</div>
              }
            </div>
          }
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-md-8">
        <label for="installmentAmount" class="mb-1"><p>Your installments would be set at:</p></label>
        <!-- Installment Amount-->
        <input readonly="readonly"
          id="installmentAmount"
          name="installmentAmount"
          [(ngModel)]="installmentAmountProperty"
          required
          #installmentAmountCtrl="ngModel" type="text" class="form-control col-md-6"
          [class.is-invalid]="installmentAmountCtrl.invalid && (installmentAmountCtrl.dirty || installmentAmountCtrl.touched)">
          @if (installmentAmountCtrl.invalid && (installmentAmountCtrl.dirty || installmentAmountCtrl.touched)) {
            <div>
              @if (installmentAmountCtrl.errors?.['required']) {
                <div class="invalid-feedback d-block">Invalid amount, please try again.</div>
              }
            </div>
          }
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 col-md-8">
          <p>If there is anything we need to confirm with you, we will contact you.</p>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 col-md-8">
          <label for="selectedDate" class="mb-1"><p>Commencement date</p></label>
          <br/>
          <!-- Commencement date-->
          <mat-form-field appearance="fill">
            <mat-label>dd/mm/yyyy</mat-label>
            <input required disabled matInput name="picker" [matDatepicker]="picker" [min]="minDate" [max]="maxDate"
              [(ngModel)]="selectedDate" (dateChange)="onDateChange($event)" #datePickerCtrl="ngModel" [ngModelOptions]="{standalone: true}">
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker disabled="false"></mat-datepicker>
            </mat-form-field>

            <p>Please allow 2 business days from submitting.</p>

            @if (datePickerCtrl.invalid && (datePickerCtrl.dirty || datePickerCtrl.touched)) {
              <mat-error>
                <div>
                  @if (datePickerCtrl.errors?.['required']) {
                    <div class="invalid-feedback d-block">You must enter a date.</div>
                  }
                </div>
              </mat-error>
            }

          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-8">
            <h1 class="mb-3">Important</h1>
            <p>By submitting this application, you declare that you are the named Account Holder of the Urban Utilities Water and Sewerage Account for the property stated above, and you understand that you may be required to provide further information in order for your request to be processed.</p>
            <p>If the arrangement requested in this application is approved, interest will not accrue on your account while you are honouring the arrangement.</p>
            <p>Please remember it's important that you contact us if you can't meet these agreed installment payments, so that we can assist with an arrangement that suits your needs.</p>
            <p><strong style="font-weight: 700; text-shadow: 0.5px 0 0 currentColor, -0.5px 0 0 currentColor;">Your declaration</strong></p>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" value="" id="declarationAccepted"
                [(ngModel)]="declarationAccepted" #declarationCtrl="ngModel" required [ngModelOptions]="{standalone: true}">
                <label class="form-check-label" for="declarationAccepted">I confirm that these details are accurate.</label>
              </div>
              @if (declarationCtrl.invalid && (declarationCtrl.dirty || declarationCtrl.touched)) {
                <div>
                  @if (declarationCtrl.errors?.['required']) {
                    <div class="invalid-feedback d-block">You must agree before submitting.</div>
                  }
                </div>
              }
              <br/>
            </div>
          </div>
          <div class="row" style="padding-bottom: 50px;">
            <div class="col-sm-12 col-md-8">
              <div class="form-group">
                <button id="submitButton" name="submitButton" type="submit" class="btn btn-primary rounded-pill"
                [disabled]="paymentForm.invalid || declarationCtrl.invalid || !selectedDate">Submit</button>
              </div>
            </div>
          </div>
        </form>
        @if (showError) {
          <div class="row">
            <div class="col-lg-12"> &nbsp;<br>
              <div class="alert alert-danger col-sm-12 col-md-8" role="alert" [innerHTML]="error_message"></div>
            </div>
          </div>
        }
      </div>
